import type {IVStoreState} from '../useIVStore.ts';

export const getDocumentType = (state: IVStoreState) => state.setupData.documentType;
